import type { IdempotencyKeySessionStorage } from '@ctct/infrastructure-layer';

export class IdempotencyKeyService {
  private currentKey: string;

  constructor(private accountId: number | undefined, private storage: IdempotencyKeySessionStorage) {
    const existing = storage.loadIdempotencyKey(accountId) as string | null;

    this.currentKey = existing ?? this.generateAndPersist();
  }

  public api() {
    return {
      getIdempotencyKey: () => this.currentKey,
      clearIdempotencyKey: () => {
        this.storage.clearIdempotencyKey(this.accountId);
        this.currentKey = this.generateAndPersist();
      },
    };
  }

  private generateAndPersist(): string {
    const bytes = new Uint8Array(16);

    crypto.getRandomValues(bytes);

    const key = btoa(String.fromCharCode(...bytes));

    this.storage.saveIdempotencyKey(key, this.accountId);

    return key;
  }
}
